<app-breadcrumb [title]="'Checkout'|translate" [breadcrumb]="'Checkout'|translate "></app-breadcrumb>
<!-- <div *ngIf="(cartItems$|async) as cartItems">
    <pre>
        {{cartItems | json}}
    </pre>
</div> -->
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true">
    <p style="color: white"> Loading... </p>
</ngx-spinner>

<section class="section-b-space">
    <div class="container padding-cls">
        <div class="checkout-page">
            <div class="checkout-form">
                <!-- <div>
                    <pre *ngIf="orderItems">
                    {{orderItems |json}}
                </pre>
                </div> -->
                <form>
                    <div class="row">
                        <div class="col-lg-6 col-sm-8 col-xs-12">


                        </div>

                        <div class="col-lg-12 col-sm-12 col-xs-12">
                            <div class="checkout-details">


                                <!-- List of items -->
                                <div class="order-box">




                                    <div class="container" *ngIf="(cartItems$|async) as cartItems;">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <table class="table cart-table table-responsive-xs"
                                                    style="color: white;">
                                                    <thead>
                                                        <tr class="table-head">
                                                            <th scope="col">{{'image'|translate}}</th>
                                                            <th scope="col">{{'Product name'|translate}}</th>
                                                            <th scope="col">{{'Quantity'|translate}}</th>
                                                            <th scope="col">{{'Total'|translate}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody *ngFor="let product of cartItems">
                                                        <tr style="color: white;"
                                                            [ngStyle]="{'border': product.quantitiesInCartItem>product.stock?'5px solid red':''}">

                                                            <td>
                                                                <a
                                                                    [routerLink]="['/shop/product/left/sidebar/', product.barcode]">
                                                                    <img [src]="product.imageName"
                                                                        style="border-radius: 15px; height: 100px;">
                                                                </a>
                                                            </td>

                                                            <td>
                                                                <a [routerLink]="['/shop/product/left/sidebar/', product.barcode]"
                                                                    style="align-items: center; color: white;">{{
                                                                    product.productName | titlecase }}
                                                                </a>
                                                            </td>
                                                            <td>
                                                                <h4>
                                                                    {{ product.quantitiesInCartItem }} X {{
                                                                    (product.unitPrice | discount:product) |
                                                                    currency:productService?.Currency.currency:'symbol'
                                                                    }}
                                                                </h4>
                                                            </td>
                                                            <td>
                                                                <h4 class="td-color">
                                                                    {{ ((product.unitPrice | discount:product) *
                                                                    product.quantitiesInCartItem) |
                                                                    currency:productService?.Currency.currency:'symbol'
                                                                    }}
                                                                </h4>
                                                            </td>
                                                        </tr>
                                                    </tbody>

                                                </table>


                                            </div>
                                        </div>



                                    </div>

                                    <div class="striped-line">
                                    </div>



                                    <ul class="sub-total">
                                        <li style="color: white;">
                                            <input type="checkbox" style="font-size: 30px;"
                                                (click)="onCheckFreeSample($event)"> {{'Free Sample'|translate}}
                                        </li>

                                        <li style="color: white;">
                                            <!-- Subtotal <span class="count">{{ getTotal | async | -->
                                            {{'Sub total'|translate}} <span class="count">{{ totalPrice
                                                |currency:productService?.Currency.currency:'symbol'}}</span>
                                        </li>
                                        <li *ngIf="(dinarRate$|async) as dinarRate" style="color: white;">

                                            {{'Dinar Total'|translate}} ({{dinarRate|number:'1.0-1'}})

                                            <!-- <span class="count">{{ (totalPrice | async) *dinarRate| currency:'IQD'}}</span> -->
                                            <span class="count">{{ totalPrice *dinarRate| currency:'IQD'}}</span>
                                        </li>


                                    </ul>


                                    <ul class="sub-total" *ngIf="isWholeSaleAccount">

                                        <!-- coupon -->
                                        <li>
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control count"
                                                    [disabled]="couponDisabled" matInput #couponQuery
                                                    placeholder="Coupon">
                                                <div class="input-group-append">
                                                    <button *ngIf="!isCouponApplied" type="button"
                                                        class="btn btn-outline-secondary" style="width: 163px;"
                                                        [hidden]="couponDisabled" [disabled]="couponDisabled"
                                                        (click)="applyCoupon(couponQuery.value)">
                                                        {{'Apply Coupon'|translate}} </button>

                                                    <button *ngIf="isCouponApplied" type="button"
                                                        class="btn btn-outline-secondary"
                                                        style="width: 200px; color: brown;" [hidden]="couponDisabled"
                                                        [disabled]="couponDisabled"
                                                        (click)="applyCoupon(couponQuery.value)">
                                                        {{'Remove'|translate}} </button>

                                                </div>
                                            </div>
                                        </li>


                                        <!-- Reward -->
                                        <li *ngIf="(customer$|async) as customer  ">
                                            <div>
                                                <div class="input-group mb-3">
                                                    <input type="text" class="form-control count" value="10"
                                                        [disabled]="true" type="number" matInput #rewardQuery
                                                        placeholder="Reward" style="color: black;"
                                                        placeholder="just  $10 use">
                                                    <div class="input-group-append">
                                                        <button *ngIf="!isRewardApplied && customer.reward>=10"
                                                            type="button" class="btn btn-outline-secondary"
                                                            [hidden]="rewardDisabled" [disabled]="rewardDisabled"
                                                            (click)="applyReward(rewardQuery.value)"> {{'Apply
                                                            Reward'|translate}}
                                                            ($10)</button>
                                                        <button *ngIf="isRewardApplied" type="button"
                                                            class="btn btn-outline-secondary" [hidden]="rewardDisabled"
                                                            style="width: 200px; color: brown;"
                                                            (click)="applyReward(rewardQuery.value)">
                                                            {{'Remove'|translate}}</button>

                                                    </div>
                                                </div>
                                                <div>
                                                    <span *ngIf="customer.reward>=10" style="color: white;">{{'Your
                                                        reward is'|translate}}
                                                        {{customer.reward|currency:'USD'}} {{'but you can just use $10
                                                        as reward.'|translate}}</span>
                                                    <span *ngIf="customer.reward<10" style="color: white;">{{'You must
                                                        have $10 or more to
                                                        apply it.'|translate}}</span>
                                                </div>

                                            </div>

                                        </li>

                                    </ul>

                                    <ul class="total">
                                        <li style="font-size: 20px; font-weight: bold; color:white">
                                            {{'Total'|translate}}
                                            <span class="count" style="font-weight: bold; color: white;"
                                                [ngClass]="totalPriceAfterDiscount>0?'line-through':''">
                                                <!-- {{getTotal | async |currency:'USD':'symbol-narrow':'0.0'}}  -->
                                                {{totalPrice |currency:'USD':'symbol-narrow':'0.0'}}
                                                {{'Total Price'|translate}}
                                            </span>


                                            <span class="count" *ngIf="totalPriceAfterDiscount>0"
                                                style="color: green; font-weight: bold;">
                                                {{totalPriceAfterDiscount |currency:'USD':'symbol-narrow':'0.0'}}
                                            </span>


                                        </li>



                                        <li style="margin-top: -40px;">
                                            <div class="striped-line">
                                            </div>
                                        </li>


                                        <!-- OrderTrack -->
                                        <li>
                                            <!-- delivery -->
                                            <div style="margin-top: 35px;">

                                                <input type="radio" name="track" id="delivery" value="delivery" checked
                                                    (change)="onOrderTrack($event)">
                                                <label for="delivery"
                                                    style="margin-left: 10px; color: white">{{'Delivery'|translate}}

                                                    <a *ngIf="isDelivery" href="#" [routerLink]="['/pages/dashboard']"
                                                        type="button" class="btn overBtn" style="margin-left: 20px; height: 30px; background: khaki;border-radius: 20px;
                                                    font-size: 10px;">
                                                        {{'Edit Address'|translate}}
                                                    </a></label>

                                                <!-- Taxi & Balance -->
                                                <div style="margin-left: 10px;" *ngIf="isDelivery">

                                                    <!-- taxi -->
                                                    <div *ngIf="(customer$|async) as customer">
                                                        <input type="radio" name="orderTrackPayment" id="paidCashToTaxi"
                                                            value="paidCashToTaxi" [checked]='true'
                                                            (change)="onOrderTrackPayment($event)">
                                                        <label for="pickup"
                                                            style="margin-left: 10px; color:white">{{'Pay cash to
                                                            taxi driver'|translate}} </label>
                                                        <label for="pickup" style="margin-left: 10px; color: brown; "> -
                                                            {{customer.address1}} - {{customer.cityName}} </label>

                                                        <!-- insideHawler & outsideHalwer -->
                                                        <div style="margin-left: 30px;" *ngIf="isOrderTrackPlace">

                                                            <!-- insideHawler -->
                                                            <div *ngIf="isInHalwer(customer.cityName)">
                                                                <input type="radio" name="orderTrackPaymentPlace"
                                                                    id="insideHawler" value="insideHawler"
                                                                    style="color: white;"
                                                                    (change)="onOrderTrackPlace($event)"
                                                                    [checked]='true'>
                                                                <label for="pickup"
                                                                    style="margin-left: 8px;color: white; ">{{insideHawler|translate}}
                                                                    - $ 1.99 </label>
                                                            </div>

                                                            <!-- outsideHalwer -->
                                                            <div>
                                                                <input type="radio" name="orderTrackPaymentPlace"
                                                                    id="outsideHalwer" value="outsideHalwer"
                                                                    style="color: white;"
                                                                    (change)="onOrderTrackPlace($event)"
                                                                    [checked]='!isInHalwer(customer.cityName)'>
                                                                <label for="pickup"
                                                                    style="margin-left: 8px; color:white">{{outsideHalwer|translate}}
                                                                    - $ 2.99 </label>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <!-- Balance -->
                                                    <div style="border-top: 30px;">
                                                        <input type="radio" name="orderTrackPayment" id="cashByBalance"
                                                            value="cashByBalance"
                                                            (change)="onOrderTrackPayment($event)">
                                                        <label for="pickup"
                                                            style="margin-left: 10px;color:white ">{{'Pay by
                                                            balance'|translate}}</label>
                                                        <h4
                                                            style="color: brown; font-weight: bold; margin-left: 10px;margin-bottom:10px; font-size: 13px;">
                                                            {{'Send Balance by Korak Number: 0750-816-6007'|translate}}
                                                        </h4>
                                                        <h4
                                                            style="color: brown; font-weight: bold; margin-left: 10px;margin-bottom:15px; font-size: 13px;">
                                                            {{'Send Balance By Fast Pay: 0750-816-6007'|translate}}
                                                        </h4>
                                                    </div>

                                                </div>
                                            </div>


                                            <!-- pickup -->
                                            <div style="margin-top: 30px;">
                                                <input type="radio" name="track" id="pickup" value="pickup"
                                                    (change)="onOrderTrack($event)">
                                                <label for="pickup" style="margin-left: 10px; color:white">{{'Pick Up in
                                                    Store'|translate}}</label>
                                                <div style="margin-left: 10px;" *ngIf="isPickUp">
                                                    <!-- taxi -->
                                                    <div>
                                                        <input type="radio" name="orderTrackPayment" id="PaidCash"
                                                            value="pickUpPaidCash" [checked]='true'
                                                            (change)="onOrderTrackPayment($event)">
                                                        <label for="pickup"
                                                            style="margin-left: 10px; color:white">{{'Pay
                                                            cash'|translate}}</label>
                                                        <div>
                                                            <div *ngIf="(customer$|async) as customer">
                                                                <h4
                                                                    style="color: brown; font-weight: bold; margin-left: 10px;margin-bottom:15px; font-size: 13px;">
                                                                    {{customer.address1}} - {{customer.cityName}}</h4>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- Balance -->
                                                    <div>
                                                        <input type="radio" name="orderTrackPayment" id="pickup"
                                                            value="pickUpcashByBalance"
                                                            (change)="onOrderTrackPayment($event)">
                                                        <label for="pickup"
                                                            style="margin-left: 10px; color:white">{{'Pay by
                                                            balance'|translate}}</label>
                                                        <h4
                                                            style="color: brown; font-weight: bold; margin-left: 10px;margin-bottom:10px; font-size: 13px;">
                                                            {{'Send Balance by Korak Number: 0750-816-6007'|translate}}
                                                        </h4>
                                                        <h4
                                                            style="color: brown; font-weight: bold; margin-left: 10px;margin-bottom:15px; font-size: 13px;">
                                                            {{'Send Balance By Fast Pay: 0750-816-6007'|translate}}
                                                        </h4>
                                                    </div>


                                                </div>



                                            </div>

                                        </li>
                                    </ul>

                                </div>




                                <!-- payment -->
                                <div class="payment-box" *ngIf="(cartItems$|async) as cartItems;">
                                    <div class="upper-box">
                                        <div class="payment-options">
                                            <ul>


                                                <!-- <li>
                                                    <div class="radio-option paypal">
                                                        <input type="radio" [(ngModel)]="payment" [value]="'Paypal'" name="payment-group" id="payment-3">
                                                        <label for="payment-3">PayPal<span class="image"><img src="assets/images/paypal.png" alt="" /></span></label>
                                                    </div>
                                                </li> -->
                                            </ul>
                                        </div>
                                    </div>

                                    <!-- <div class="text-right" style="margin-right: 3%; margin-bottom: 15px;">
                                        <input type="checkbox" style="font-size: 50px;" (click)="onCheckFreeSample($event)"> Free Sample -->
                                    <!-- <ngx-paypal [config]="payPalConfig" *ngIf="payment == 'Paypal'"></ngx-paypal> -->
                                    <!-- </div> -->
                                    <div class="text-right">
                                        <button type="submit" class="btn-solid btn" *ngIf="!hiddenOrderButton"
                                            (click)="openConfirmBox(cartItems)">
                                            {{'Order'|translate}}
                                        </button>
                                        <!-- <ngx-paypal [config]="payPalConfig" *ngIf="payment == 'Paypal'"></ngx-paypal> -->
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</section>